// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__24bcA","header":"PatientBlock_header__1KHR9","label":"PatientBlock_label__2-sDe","option":"PatientBlock_option__fyKMw"};